// extracted by mini-css-extract-plugin
export default {"card":"Login_card__o1F-W","submitBtnContainer":"Login_submitBtnContainer__Mb64g","loginTableContainer":"Login_loginTableContainer__lCuZn"};